import { Button, Checkbox, CheckboxField, TextArea, Typography } from '@finam/web-ui-kit';
import React from 'react';
import ReactModal from 'react-modal';
import { JsxAttribute } from 'typescript';
import { IOfferData } from '../../Services/ResponseData';
import useWindowDimensions from '../../Services/UseWindowDimensions';
import { WebService } from '../../Services/WebService';
import { TokenContext } from '../../TokenContext';
import './Steps.scss';

interface IState {
    personalDataAccess: boolean;
    offerData?: IOfferData;
    cancelPanelOpen?: boolean;
    cancelCause?: string
}

interface IProps {
    endAction: () => void
    passed: boolean;
}


// export default function OfferStep(props: IProps): JSX.Element {
//     const { height, width } = useWindowDimensions();
//     return <OfferStepInner {...props} height={height} />
// }

export default class OfferStep extends React.Component<IProps, IState>{
    static contextType?= TokenContext;
    context!: React.ContextType<typeof TokenContext>;


    constructor(props: any) {
        super(props);
        this.state = {
            personalDataAccess: false
        }
    }

    componentDidMount(): void {
        new WebService(this.context.token).GetOffer()
            .then(res => this.setState({ offerData: res }))
    }


    private SplitOfferList(listString: string, itemRender: (s: string, i: number) => JSX.Element): JSX.Element | undefined {
        if (!listString) return undefined;
        const items = listString.split('\r\n');
        return <>{items.map((p, i) => itemRender(p, i))}</>
    }

    private OnDecision(desicion: boolean) {
        new WebService(this.context.token).AcceptOffer(desicion, this.state.cancelCause || '')
            .then(_ => { this.props.endAction() });
    }

    render() {
        return <div className='offerSter'>
            <Typography variant='h2' className='step-title'>{this.state.offerData?.firstName}, добрый день!</Typography>
           {!!this.state.offerData && <>
                <div className='offer-form'>
                    <p>Поздравляем с успешным прохождением всех этапов знакомства с «Финамом». Уверены, что ваши профессиональные навыки и личные качества могут прекрасно раскрыться и реализоваться в задачах и проектах компании, и рады пригласить присоединиться к команде «Финама»!</p>
                    <p>Ваша должность <b>{this.state.offerData.strPost}{this.state.offerData.strDepartment && ` ${this.state.offerData.strDepartment}`}</b>.</p>
                    <p>Оплата труда на этой должности составляет {this.state.offerData.probationSalary} руб. в месяц на время испытательного срока и {this.state.offerData.salary} руб. в месяц — после прохождения испытательного срока. Обе суммы указаны после вычета подоходного налога.</p>
                    {this.state.offerData.probation > 0 && <p>Испытательный период составляет <b>{this.state.offerData.probation}</b> месяца.</p>}
                    {!!this.state.offerData.goals && <>
                        <p>На период испытательного срока перед вами будут стоять следующие задачи:</p>
                        {this.SplitOfferList(this.state.offerData.goals, (s, i) => <p key={`goal_${i}`}>{s}</p>)}</>}

                    {this.SplitOfferList(this.state.offerData.bonuses, (s, i) => <p key={`bonus_${i}`}>{s}</p>)}
                    <p>Команда «Финама» демократичная, приветливая, мы обращаемся друг к другу на «ты» и поддерживаем дружественную атмосферу внутри. У нас много внутрикорпоративных активностей — клубы по бегу, йоге, футболу и другим видам спорта, мы проводим благотворительные акции и вместе празднуем дни рождения!</p>
                    <p>Надеемся, что наше сотрудничество будет интересным, насыщенным и долгосрочным!</p>
                </div>
            </>
            }
            {!this.props.passed &&
                <><div className='acceptWrapper'>
                    <CheckboxField
                        label="Согласие на обработку персональных данных"
                        checked={this.state.personalDataAccess}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => { this.setState({ personalDataAccess: checked }) }}
                    />
                </div>
                    <div className='actionSection'>
                        <Button disabled={!this.state.personalDataAccess} onClick={() => { this.OnDecision(true) }}>Принять</Button>
                        <Button disabled={!this.state.personalDataAccess} variant='secondary' onClick={() => { this.setState({ cancelPanelOpen: true }) }}>Отказаться</Button>
                    </div></>
            }
            <ReactModal
                isOpen={!!this.state.cancelPanelOpen}
                contentLabel='Отклонить предложение' ariaHideApp={false}
                style={
                    { content: { height: '400px', left: '50%', top: '50%', position: 'absolute', transform: 'translate(-50%, -50%)', borderRadius: '10px' }, overlay: { zIndex: 50 } }
                }
                overlayClassName='declineModal'
            >

                <div className='managerModal-close' style={{ textAlign: 'end' }}><img style={{ cursor: 'pointer' }} src={process.env.PUBLIC_URL + 'icons/Close.svg'} onClick={(e) => { e.stopPropagation(); this.setState({ cancelPanelOpen: false }); }} /></div>
                <div className='cancel-form'>
                    <Typography variant='h2'>Почему вы решили отказаться от сотрудничества с нами?</Typography>
                    <Typography variant='body14'>Пожалуйста, напишите причину в поле ниже</Typography>
                    <TextArea minRows={5} value={this.state.cancelCause} onChange={(val) => this.setState({ cancelCause: val.target.value })}></TextArea>
                    <div style={{ textAlign: 'center' }}>
                        <Button onClick={() => { this.OnDecision(false) }}>Отправить</Button>
                    </div>
                </div>
            </ReactModal>
            <ReactModal
                isOpen={!!this.state.cancelPanelOpen}
                contentLabel='Отклонить предложение' ariaHideApp={false}
                overlayClassName='declineModalMobile'
            >
                <div className='managerModal-close' style={{ textAlign: 'end' }}><img style={{ cursor: 'pointer' }} src={process.env.PUBLIC_URL + 'icons/Close.svg'} onClick={(e) => { e.stopPropagation(); this.setState({ cancelPanelOpen: false }); }} /></div>
                <div className='cancel-form'>
                    <Typography variant='body16'><b>Почему вы решили отказаться от сотрудничества с нами?</b></Typography>
                    <TextArea minRows={3} value={this.state.cancelCause} onChange={(val) => this.setState({ cancelCause: val.target.value })}></TextArea>
                    <div style={{ textAlign: 'center' }}>
                        <Button onClick={() => { this.OnDecision(false) }}>Отправить</Button>
                    </div>
                </div>
            </ReactModal>
        </div>
    }
}